/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Hero_TitleInputs */

const en_rd_hero_title = /** @type {(inputs: Rd_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is your repo ready for AI agents?`)
};

const id_rd_hero_title = /** @type {(inputs: Rd_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repo-mu siap dikerjakan agent AI?`)
};

/**
* | output |
* | --- |
* | "Is your repo ready for AI agents?" |
*
* @param {Rd_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_hero_title = /** @type {((inputs?: Rd_Hero_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Hero_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_hero_title(inputs)
	return en_rd_hero_title(inputs)
});